mutation DeleteAudienceForEntityList($input: AudienceDeleteInput!) {
    audienceDelete(input: $input) {
        audience {
            id
        }
    }
}
